var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-textarea',{staticClass:"container-comment-reply pa-0",attrs:{"background-color":"transparent","color":"#96a7af","dense":"","dark":"","outlined":"","readonly":"","auto-grow":"","hide-details":""},domProps:{"innerHTML":_vm._s(_vm.html)}})}
var staticRenderFns = []

export { render, staticRenderFns }